import React from 'react';
import $ from "jquery";

const Marker = ({ text }) => {
  // const handleClick = (e) => {
  //   // $('html, body').animate({
  //   //     scrollTop: $(e.currentTarget.dataset.myobjid).offset().top
  //   // }, 500);
  //   $('html, body').animate({
  //     scrollTop: $(e.currentTarget.dataset.myobjid).offset().top - 200
  //   }, 2000);

  //   let mapid = e.currentTarget.dataset.myobjid.replace(/#/g, "")

  //   $(e.currentTarget.dataset.myobjid).addClass("active ss").siblings().removeClass("active")
  //   $(".marker .map-marker-"+mapid).addClass("active").siblings().removeClass("active")
  //   console.log("$$$$$", e.currentTarget.dataset.myobjid.replace(/#/g, ""), mapid)
  // }

  let mappropertyid = text;

  return (
    <div className={"map-marker"} id={"map_marker_"+mappropertyid} data-myobjid={text}>
      <i style={{ pointerEvents: "all"}} className={"icon icon-map-marker map-marker-"+mappropertyid}  onClick={
        (e) => {
          $(".icon-map-marker.active").removeClass("active");

          e.target.classList.add("active");
          $('html, body').animate({
            scrollTop: $("#map_marker_"+mappropertyid).offset().top - 200
          }, 100);

          $("#map_marker_"+mappropertyid).addClass("active").siblings().removeClass("active");
      
          // $(this).addClass("active ss")
          // e.target.style.display="none";
        }
    }></i>
      {/* id={text.replace(/#/g, "")} */}
    </div>
  )
}

export default React.memo(Marker);